import { Snackbar } from "@mui/material";
import { Alert } from '@mui/material';
import { useEffect } from "react";
import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { httpErrorSelector, setHttpError } from "../store/messagesSlice";
const NotificationContext = createContext({
  show: () => ({}),
});

export const useNotify = () => useContext(NotificationContext);

export function NotificationProvider({ children }) {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const httpError = useSelector(httpErrorSelector);
  const [message, setMessage] = useState("");
  const [options, setOptions] = useState({});
  const dispatch = useDispatch();
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const show = useCallback((message, options) => {
    setMessage(message);
    setSnackbarOpen(true);
    const severity = options?.severity || "success";
    setOptions({ severity });
  }, []);

  const functions = useMemo(() => ({ show }), [show]);
  useEffect(() => {
    if (!Boolean(httpError)) return;

    functions.show(httpError, { severity: "error" });
    setTimeout(() => {
      dispatch(setHttpError(null));
    }, 1000);
  }, [functions, httpError, dispatch]);

  return (
    <NotificationContext.Provider value={functions}>
      <Snackbar
        open={snackbarOpen}
        onClose={handleSnackbarClose}
        autoHideDuration={3000}
      >
        <Alert
          severity={options.severity}
          variant="filled"
          onClose={handleSnackbarClose}
        >
          {message}
        </Alert>
      </Snackbar>

      {children}
    </NotificationContext.Provider>
  );
}
